<template>
  <div class="CProductInfo">
    <!-- 搜索框 -->
    <div class="searchBox">
      <!-- <el-input class="searchInput" placeholder="产品编号" v-model="keyword.number" clearable></el-input> -->
      <el-input class="searchInput" placeholder="产品名称或编号" v-model="keyword.name" clearable @keyup.enter.native="ProductList(1)"></el-input>
      <el-select v-model="keyword.type" placeholder="请选择类别" clearable @change="ProductList(1)">
        <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in typeList" :key="index"></el-option>
      </el-select>
      <el-button class="searchBtn" type="primary" @click="ProductList(1)">搜 索</el-button>
    </div>
    <!-- 添加信息 -->
    <div class="addButton">
      <el-button type="primary" @click="openDio('add')">添加</el-button>
      <el-button type="primary" @click="openDio('import')">导入</el-button>
    </div>

    <el-table v-loading="loading" :data="productData" style="width: 100%">
      <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
      <el-table-column label="产品编号" prop="Id" fixed></el-table-column>
      <el-table-column label="产品名称" prop="ProductName" fixed width="150"></el-table-column>
      <el-table-column label="产品批号" prop="ProductNumber"></el-table-column>
      <el-table-column label="类别" prop="Type"></el-table-column>
      <el-table-column label="规格" prop="Spec"></el-table-column>
      <el-table-column label="单位" prop="Unit"></el-table-column>
      <el-table-column label="重量" prop="Weight"></el-table-column>
      <el-table-column label="供应商" prop="Supplier"></el-table-column>
      <el-table-column label="生产日期" prop="Date"></el-table-column>
      <el-table-column label="有效期" prop="Validity"></el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button type="text">打印</el-button>
          <el-button type="text" @click="openDio('edit',scope.row)">修改</el-button>
          <el-button type="text" @click="openDio('del',scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging" v-if="total>limits">
      <el-pagination
        @current-change="CurrentChange"
        :current-page.sync="curr"
        :page-size="limits"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="dioTitle" :visible.sync="productDio" :width="dioWidth" class="configDio wareDio" center>
      <div class="contDio">
        <el-form ref="form" :inline="true" :rules="rules" :model="dioform" label-width="90px">
          <el-form-item label="产品名称:" prop="ProductName">
            <el-input v-model="dioform.ProductName"></el-input>
          </el-form-item>
          <el-form-item label="产品批号:" prop="ProductNumber">
            <el-input v-model="dioform.ProductNumber"></el-input>
          </el-form-item>
          <el-form-item label="类别:" prop="Type">
            <el-select v-model="dioform.Type">
              <el-option v-for="(item,index) in typeList" :value="item.Id" :label="item.Name" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:" prop="Spec">
            <el-input v-model="dioform.Spec"></el-input>
          </el-form-item>
          <el-form-item label="单位:">
            <el-select v-model="dioform.Unit">
              <el-option :value="item.id" :label="item.name" v-for="(item,index) in UnitList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="重量:" prop="Weight">
            <el-input v-model="dioform.Weight"></el-input>
          </el-form-item>
          <el-form-item label="供应商:" prop="Supplier">
            <el-select v-model="dioform.Supplier">
              <el-option :value="item.id" :label="item.name" v-for="(item,index) in SupplierList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产日期:" prop="Date">
            <el-date-picker
              v-model="dioform.Date"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="有效期:" prop="Validity">
            <el-input v-model="dioform.Validity" placeholder="请输入有效期（单位：天）"></el-input>
            <!-- <el-date-picker
              v-model="dioform.Validity"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期">
            </el-date-picker> -->
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="submitProduct('form')">确认</el-button>
        <el-button @click="productDio = false">取消</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
  import { bussinessApi } from '../../../../../static/js/api'
  import { showToast } from "../../../../../static/js/utility/utility.js"
  var vm
  export default {
    data(){
      return {
        //搜索
        keyword:{
          name:'',//产品名称
          type:'',//类别
        },

        loading:false,//产品
        productData:[],//产品信息数据

        //分页
        curr:1,
        limits:10,
        total:10,

        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        productDio:false,//弹窗状态
        dioform:{
          Id:'',//产品编号
          ProductName:'',//产品名称
          ProductNumber:'',//产品批号
          Type:'',//类别
          Spec:'',//规格
          Unit:'',//单位
          Weight:'',//重量
          Date:'',//生产日期
          Validity:'',//有效期
        },

        rules:{
          ProductName:[
            { required: true, message: '请输入产品名称', trigger: 'blur' },
          ],
        },
        UnitList:[],
        typeList:[],//类型列表
        SupplierList:[]

      }
    },
    async created(){
      vm = this
      this.ProductList();//产品列表
      this.ProductTypeList();//类别
      // this.ProductUnitList();//单位
      // this.ProductSupplierList();//供应商
    },
    methods:{
      //更新产品
      async UpdateProduct(){
        var data = {}
        if(vm.dioType !='del'){
          data = vm.dioform
          data.ProductId = vm.dioform.Id
          delete data.Id
          if(vm.dioType == 'add'){
            delete data.ProductId;//如果是添加删除这个产品ID属性
          }
        }else if(vm.dioType == 'del'){
          data.ProductId = vm.dioform.Id
        }
        const res = await bussinessApi.UpdateProduct(data)
        if(res.ErrCode == 0){
          
          vm.productDio = false
          vm.ProductList(1)
          showToast('操作成功')
          vm.dioform={
            Id:'',//产品编号
            ProductName:'',//产品名称
            ProductNumber:'',//产品批号
            Type:'',//类别
            Spec:'',//规格
            Unit:'',//单位
            Weight:'',//重量
            Date:'',//生产日期
            Validity:'',//有效期
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      //提交产品（验证）
      submitProduct(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            vm.UpdateProduct()
          } else {return false;}
        });
      },
      //打开弹窗
      openDio(type,info){
        vm.dioType = type
        if(type !='del'){
          if(type == 'add'){
            vm.dioWidth="700px"
            vm.dioTitle="添加产品"
          }else if(type == 'edit'){
            vm.dioWidth="700px"
            vm.dioTitle = "修改产品"
            vm.dioform.Id = info.Id
            vm.dioform.ProductName = info.ProductName
            vm.dioform.ProductNumber = info.ProductNumber
            vm.dioform.Type = info.Type
            vm.dioform.Spec = info.Spec
            vm.dioform.Unit = info.Unit
            vm.dioform.Weight = info.Weight
            vm.dioform.Date = info.Date
            vm.dioform.Validity = info.Validity
          }else if(type == 'import'){
            //导入操作todu
          }
          vm.productDio = true
        }else{
          vm.dioform = info
          this.$confirm('确定删除该产品？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            vm.UpdateProduct()
          }).catch(() => {});
        }
      },
      //获取产品列表
      async ProductList(curr,limits){
        let data = {
          'Product': vm.keyword.name,
          'TypeId': vm.keyword.type,
          'Curr': curr ? curr : vm.curr,
          'Limits': limits ? limits : vm.Limits
        }
        vm.loading = true
        const res = await bussinessApi.ProductList(data)
        vm.loading = false
        if(res.ErrCode == 0 ){
          if(res.Result){
          vm.productData = res.Result.List
          vm.curr = parseInt(res.Result.Curr)
          vm.total = parseInt(res.Result.Total)
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
        this.ProductList(val)
      },
      //获取产品类型
      async ProductTypeList(){
        let data = {
          'KeyWord':'',
          'Curr':1,
          'Limits':99999
        }
        const res = await bussinessApi.ProductTypeList(data)
        if(res.ErrCode == 0){
          vm.typeList = res.Result.List
        }else{
          showToast(res.ErrMsg)
        }
      },
      //获取产品单位
      async ProductUnitList(){
        let data = {
          'Curr':1,
          'Limits':99999
        }
        const res = await bussinessApi.ProductUnitList(data)
        if(res.ErrCode == 0){
          vm.UnitList = res.Result.list
        }else{
          showToast(res.ErrMsg)
        }
      },
      //获取产品供应商
      async ProductSupplierList(){
        let data = {
          'Curr':1,
          'Limits':99999
        }
        const res = await bussinessApi.ProductSupplierList(data)
        if(res.ErrCode == 0){
          vm.SupplierList = res.Result.list
        }else{
          showToast(res.ErrMsg)
        }
      },
    },
  }
</script>
<style lang="scss">
.CProductInfo{
  padding: 24px;
  .w100{
    width: 100px;
  }
  .w300{
    width: 300px;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 300px;
    }
  }
  .contDio{
    .el-form-item{
      width: 49%;
      margin-right: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/CStorage/CProductManage/CProductInfo.vue